/* MCR · Select Combos — Colour 1 / Colour 2 selects drive the product form's variant id. */
(function () {
  if (customElements.get('mcr-combo-select')) return;

  var COLORS = [
    ['flor', '#7ac943'], ['light green', '#8fd18a'], ['dark green', '#1f5c3f'], ['green', '#2e8b57'],
    ['light orange', '#f6ad6b'], ['dark orange', '#d9591c'], ['ramar orange', '#e2702a'], ['flag orange', '#f26b1d'], ['orange', '#f07f2e'],
    ['cherry', '#b3143a'], ['maroon', '#7c0f24'], ['red', '#c8102e'], ['dark rose', '#b24a6b'], ['rose', '#e38aa3'],
    ['light pink', '#f4b8c8'], ['onion', '#d98fa0'], ['pink', '#e88aa8'],
    ['dark coral', '#e0604f'], ['dark corel', '#e0604f'], ['light coral', '#f59a8a'], ['light corel', '#f59a8a'], ['coral', '#ef7d6b'],
    ['dark lavendar', '#8a6fbf'], ['lavendar', '#b9a3e3'], ['lavander', '#b9a3e3'], ['lavender', '#b9a3e3'], ['dark violet', '#4b2a78'], ['violet', '#6f3fa0'],
    ['navy', '#1c2b4f'], ['light blue', '#8fb8dc'], ['sky', '#8fc6ea'], ['blue', '#2c5fb3'],
    ['mustard', '#d4a017'], ['yellow', '#f2cd2f'], ['khaki', '#b5a36b'], ['brown', '#7a4a2a'],
    ['gray', '#8a8f98'], ['grey', '#8a8f98'], ['black', '#1b1b1b'], ['white', '#fbfaf6']
  ];
  function colorFor(name) {
    var n = String(name || '').toLowerCase();
    for (var i = 0; i < COLORS.length; i++) if (n.indexOf(COLORS[i][0]) > -1) return COLORS[i][1];
    return null;
  }

  customElements.define('mcr-combo-select', class extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.querySelector('[data-cs-variants]').textContent); } catch (e) { return; }
      this.sIdx = +this.dataset.sizeIndex;
      this.cIdx = [+this.dataset.c1, +this.dataset.c2];
      this.selects = [this.querySelector('[data-cs-color="0"]'), this.querySelector('[data-cs-color="1"]')];
      if (!this.selects[0] || !this.selects[1]) return;
      var sec = this.dataset.section;
      this.form = document.getElementById('product-form-' + sec);
      this.submit = document.getElementById('ProductSubmitButton-' + sec);
      this.input = this.form && this.form.querySelector('input[name="id"]');
      this.labelEl = this.submit && this.submit.querySelector('span');
      this.baseLabel = this.labelEl ? this.labelEl.textContent.trim() : '';
      this.msg = this.querySelector('[data-cs-msg]');
      var self = this;
      this.selects.forEach(function (s) {
        s.querySelectorAll('option').forEach(function (o) { if (o.value) o.textContent = o.value.replace(/\b\w/g, function (c) { return c.toUpperCase(); }).replace(/\B\w+/g, function (w) { return w.toLowerCase(); }); });
        s.addEventListener('change', function () { self.update(true); });
      });
      // preselect from ?variant= when present, otherwise ask the shopper to choose
      var vid = +(new URLSearchParams(location.search).get('variant') || 0);
      var pre = vid && this.variants.find(function (v) { return v.id === vid; });
      if (pre) { this.selects[0].value = pre.o[this.cIdx[0]]; this.selects[1].value = pre.o[this.cIdx[1]]; }
      this.update(false);
      // Dawn may re-render the buy button on variant events; keep our lock applied
      if (this.form) this.form.addEventListener('submit', function (e) {
        if (!self.current) { e.preventDefault(); e.stopImmediatePropagation(); self.need(); }
      }, true);
    }

    find(c1, c2) {
      var a = this.cIdx[0], b = this.cIdx[1];
      return this.variants.find(function (v) { return v.o[a] === c1 && v.o[b] === c2; });
    }

    mark() {
      var self = this;
      [0, 1].forEach(function (i) {
        var other = self.selects[1 - i].value;
        self.selects[i].querySelectorAll('option').forEach(function (o) {
          if (!o.value) return;
          var any = self.variants.some(function (v) {
            return v.ok && v.o[self.cIdx[i]] === o.value && (!other || v.o[self.cIdx[1 - i]] === other);
          });
          o.disabled = !any;
          var base = o.textContent.replace(/ — sold out$/, '');
          o.textContent = any ? base : base + ' — sold out';
        });
      });
      [0, 1].forEach(function (i) {
        var dot = self.querySelector('[data-cs-dot="' + i + '"]');
        var c = colorFor(self.selects[i].value);
        dot.style.background = c || 'transparent';
        dot.classList.toggle('is-empty', !c);
      });
    }

    setButton(enabled, text) {
      if (this.form) this.form.classList.toggle('mcr-cs-locked', !enabled);
      if (!this.submit) return;
      if (enabled) { this.submit.removeAttribute('disabled'); this.submit.removeAttribute('aria-disabled'); }
      else { this.submit.setAttribute('disabled', 'disabled'); this.submit.setAttribute('aria-disabled', 'true'); }
      if (this.labelEl) this.labelEl.textContent = text;
    }

    need() {
      this.msg.textContent = this.dataset.labelNeed;
      this.classList.add('is-invalid');
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    update(fromUser) {
      this.mark();
      var c1 = this.selects[0].value, c2 = this.selects[1].value;
      this.current = null;
      this.classList.remove('is-invalid');
      if (!c1 || !c2) {
        this.msg.textContent = '';
        this.setButton(false, this.dataset.labelNeed);
        return;
      }
      var v = this.find(c1, c2);
      if (!v || !v.ok) {
        this.msg.textContent = this.dataset.labelSoldout + ' — try another colour pair';
        this.setButton(false, this.dataset.labelSoldout);
        return;
      }
      this.current = v;
      this.msg.textContent = '';
      if (this.input) { this.input.value = v.id; this.input.disabled = false; }
      this.setButton(true, this.baseLabel);
      if (fromUser) {
        var url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
        // show the Colour 1 photo first in the gallery
        var gal = document.querySelector('[data-mcr-gallery]');
        if (gal && gal.__mcrGallery && typeof gal.__mcrGallery.promoteValues === 'function') gal.__mcrGallery.promoteValues([c1]);
      }
    }
  });
})();
